import {distinctUntilChanged, filter} from 'rxjs';
import {isActivateLendingAccount$} from '@/streams/config/lending';
import {loadLendingAccountAssets$} from './assets';

isActivateLendingAccount$.pipe(distinctUntilChanged(), filter(Boolean)).subscribe(() => loadLendingAccountAssets$.next());
